import { Typography } from '@material-ui/core'
import _ from 'lodash'
import { AssemblyHeaderRow } from 'model/Project/BoMItemRow'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { RootAppState } from 'store/configureStore'

type Props = {
  issuesFilterEnabled?: boolean
  materialFilterEnabled?: boolean
  workingStepFilterEnabled?: boolean
}

export const BoMItemFilterCount = (props: Props) => {
  const filterCount = useAppSelector(
    (state: RootAppState) =>
      state.project.assemblyHeadersIds.reduce(
        (acc, headerId) => {
          return {
            assemblyCount:
              (state.project.flatView[headerId] as AssemblyHeaderRow)
                .filteredPartTypeIds?.length > 0
                ? acc.assemblyCount + 1
                : acc.assemblyCount,
            partCount:
              acc.partCount +
              (state.project.flatView[headerId] as AssemblyHeaderRow)
                ?.filteredPartTypeIds?.length,
            totalPartCount:
              acc.totalPartCount +
              (state.project.flatView[headerId] as AssemblyHeaderRow)
                ?.partTypeIds?.length,
          }
        },
        { assemblyCount: 0, partCount: 0, totalPartCount: 0 }
      ),
    _.isEqual
  )

  const { t } = useTranslation()

  return (
    <>
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        component="p"
      >
        {t('project:filters-filter-result', {
          partsCount: filterCount.partCount,
          assembliesCount: filterCount.assemblyCount,
        })}
      </Typography>

      <Typography
        variant="caption"
        align="center"
        component="p"
        color="textSecondary"
      >
        {[
          props.workingStepFilterEnabled
            ? t(`common:working-steps`, 'working steps')
            : '',
          props.materialFilterEnabled
            ? t('common:material-keywords', 'material keywords')
            : '',
          props.issuesFilterEnabled ? t('common:issues') : '',
        ]
          .filter((x) => x !== '')
          .join(' | ') ||
          t('project:filters-no-filters-applied', 'no filters applied')}
      </Typography>
    </>
  )
}
